import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase/config";
import { isTauriMode } from "./environmentDetector";
import tauriAPI from "./tauriAPI";
import { prepareWorkstationSecrets } from "./stationConnection";

const ALLOWED_KEY = "workstationAllowedStores";
export const WORKSTATION_STORES_EVENT = "workstation-allowed-stores";

export function readAllowedWorkstationStores() {
  try {
    const parsed = JSON.parse(localStorage.getItem(ALLOWED_KEY) || "[]");
    return Array.isArray(parsed) ? parsed.map((id) => String(id || "")).filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function clearAllowedWorkstationStores() {
  try {
    localStorage.removeItem(ALLOWED_KEY);
  } catch {
    // The next email login writes the list again.
  }
  window.dispatchEvent(new Event(WORKSTATION_STORES_EVENT));
}

function writeAllowedWorkstationStores(storeIds) {
  try {
    localStorage.setItem(ALLOWED_KEY, JSON.stringify(storeIds));
  } catch {
    // The open session still holds the list in memory.
  }
  window.dispatchEvent(new Event(WORKSTATION_STORES_EVENT));
}

async function thisPcFingerprint() {
  const hardware = await tauriAPI.system.getStationFingerprint();
  const fingerprint = String(hardware?.fingerprint || "").trim().toLowerCase();
  return /^[0-9a-f]{64}$/.test(fingerprint) ? fingerprint : "";
}

async function storeHasThisStation(storeId, fingerprint) {
  const snap = await getDocs(query(
    collection(db, "stores", storeId, "stations"),
    where("fingerprint", "==", fingerprint)
  ));
  return snap.docs.some((item) => String(item.data()?.status || "") === "APPROVED");
}

/** Stores where this email is an admin and this PC's fingerprint is the approved station. */
export async function restrictWorkstationStores(stores) {
  const list = Array.isArray(stores) ? stores.filter((store) => store?.id) : [];
  if (!isTauriMode()) return list;
  const ids = list.map((store) => store.id);
  let matched = [];
  try {
    const fingerprint = await thisPcFingerprint();
    if (fingerprint) {
      const checks = await Promise.all(ids.map(async (storeId) => {
        try {
          return (await storeHasThisStation(storeId, fingerprint)) ? storeId : "";
        } catch {
          return "";
        }
      }));
      matched = checks.filter(Boolean);
    }
  } catch {
    const saved = new Set(readAllowedWorkstationStores());
    matched = ids.filter((storeId) => saved.has(storeId));
  }
  writeAllowedWorkstationStores(matched);
  prepareWorkstationSecrets(matched);
  // No approved station yet: keep the admin's stores so registration and sign-out stay reachable.
  if (matched.length === 0) return list;
  const allowed = new Set(matched);
  return list.filter((store) => allowed.has(store.id));
}
